import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { get } from 'lodash';
import { CONTENT_TYPES } from 'constants/content-types';
import { navigateToPlayerPage } from 'actions/player';
import useEpisodeNavigation from './useEpisodeNavigation';
import useBannerNavigation from './useBannerNavigation';
import useInnerLinkNavigation from './useInnerLinkNavigation';
import useChannelNavigation from './useChannelNavigation';
import useCatchUpNavigation from './useCatchUpNavigation';
import useVODNavigation from './useVODNavigation';

const useContentNavigation = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const onEpisodeEnter = useEpisodeNavigation();
  const onBannerEnter = useBannerNavigation();
  const onInnerLinkEnter = useInnerLinkNavigation();
  const onChannelEnter = useChannelNavigation();
  const onCatchUpEnter = useCatchUpNavigation();
  const onVODEnter = useVODNavigation();

  const onContentEnter = useCallback(
    (item, modalFocusBackConfig, analyticsParams) => {
      // EPISODE has type VOD_ASSET, but right type in metadata
      let type = get(item.metadata, ['contentType']) || item.type;
      // We have several sources of data and sometimes they aren't normalized
      // This hack for channels which come from search page
      if (item.tvServices) type = CONTENT_TYPES.CHANNEL;

      if (type === CONTENT_TYPES.VIEW_ALL) {
        history.push(`/list-grid/${item.listId}`);
      } else if (type === CONTENT_TYPES.EPISODE) {
        onEpisodeEnter(item, modalFocusBackConfig, analyticsParams);
      } else if (type === CONTENT_TYPES.VOD_BOOKMARK) {
        dispatch(navigateToPlayerPage({ item: { id: item.targetId } }));
      } else if (type === CONTENT_TYPES.BANNER) {
        if (item.detailsUrl.indexOf('volia://') !== -1) {
          onInnerLinkEnter(item, modalFocusBackConfig);
        } else {
          onBannerEnter(item, modalFocusBackConfig);
        }
      } else if (type === CONTENT_TYPES.CHANNEL) {
        onChannelEnter(item, modalFocusBackConfig, analyticsParams);
      } else if (item.epgEventId || item.epgEvent) {
        onCatchUpEnter(item, modalFocusBackConfig, analyticsParams);
      } else if (item.subscriptionId) {
        // nothing
      } else {
        onVODEnter(item, modalFocusBackConfig, analyticsParams);
      }
    },
    [history, onEpisodeEnter, dispatch, onInnerLinkEnter, onBannerEnter, onChannelEnter, onCatchUpEnter, onVODEnter],
  );

  return onContentEnter;
};

export default useContentNavigation;
